import React, { useContext, useRef, useState } from 'react';
import './ShoppingCart.css'
import shopImage from './../../public/image/shopping-cart.png'
import Image from '../shared/Image';
import MainContext from '../../context/mainContext';
import ShoppingItem from '../shoppingCart/ShoppingItem';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import { createOrder } from '../../service/orderService';
import toast from 'react-hot-toast';
import IconLoading from '../shared/IconLoading';
import { useNavigate } from 'react-router-dom';
import ConfirmOrderModal from '../shared/ConfirmOrderModal';


const ShoppingCart = () => {

    const context = useContext(MainContext);
    const { shoppingCart: items } = context
    const [showInfo, setShowInfo] = useState(context.factureInfo ? true : false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigate = useNavigate();

    const getTotalPrice = () => {
        let total = 0;
        items.forEach(item => {
            total += (item.price * item.count)
        });
        return total;
    }
    const clearShoppingCartHandler = () => {
        context.clearShoppingCart();
    }

    const [maxInfoLength] = useState(180);
    const textInfoRef = useRef(null);
    const elementRef = useRef(null);
    const executeScroll = () => elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const setInfoHandler = (value) => {
        if (value.length > maxInfoLength) {
            return;
        }
        context.setFactureInfo(value)
        localStorage.setItem('info', value)
    }

    const submitOrderHandler = async (messengerInfo) => {
        try {
            let targetItems = [];
            items.forEach(item => {
                targetItems.push({
                    _id: item._id,
                    name: item.name,
                    count: item.count,
                    price: item.price,
                })
            })

            setSubmitLoading(true);
            setShowConfirmModal(false)
            const info = {
                customer: {
                    _id: context.loggedIn._id,
                    name: context.loggedIn.name,
                    mobile: context.loggedIn.mobile,
                    address: context.loggedIn.address,
                    color: context.loggedIn.color
                },
                items: targetItems,
                info: context.factureInfo.trim(),
                messengerName: messengerInfo.messengerName,
                messengerNumber: messengerInfo.messengerNumber,
            }
            let { status, data } = await createOrder(info);
            if (status === 201) {
                setSubmitLoading(false);
                toast.success('سفارش با موفقیت ثبت شد')
                clearShoppingCartHandler();
                navigate('/success-order', {
                    state: {
                        factureNumber: data.factureNumber,
                        totalPrice: data.totalPrice,
                        createdAt: data.createdAt,
                    }
                })
            }
        } catch (err) {
            setSubmitLoading(false);
            if (err.response && err.response.status === 401) {
                toast.error('عدم دسترسی مجاز')
                window.location.reload();
            }
            else if (err.response && err.response.status === 402) {
                toast.error('موجودی برخی اقلام کم شده است');
            }
            else if (err.response && err.response.status === 400) {
                toast.error('عملیات با خطا مواجه شد');
            }
        }
    }


   
    return (
        <React.Fragment>
            <header className='shopping-cart-title'>
                <Image
                    src={shopImage}
                    width={40}
                    height={33}
                    style={{ objectFit: 'cover', opacity: '1' }}
                />
                <h5 className='mt-1'>سبد خرید</h5>
            </header>
            {
                items.length ?
                    <div className='shopping-cart-layer'>
                        <section className='col-12 col-md-8 shop-items'>
                            {
                                items.map(item =>
                                    <ShoppingItem
                                        key={item._id}
                                        _id={item._id}
                                        image={item.image}
                                        name={item.name}
                                        price={item.price}
                                        defaultCount={item.count}
                                    />
                                )
                            }
                            <div>
                                <button className='btn btn-secondary  my-3' onClick={clearShoppingCartHandler}>
                                    <i className='fa fa-trash me-2'></i>
                                    خالی کردن سبد خرید
                                </button>

                            </div>
                        </section>
                        <section className='col-12 col-md-4'>
                            <div className='pre-facture'>
                                <header className='fw-bold fs-5'>
                                    پیش فاکتور
                                </header>
                                {
                                    context.loggedIn &&
                                    <section className='' style={{ fontSize: '.9rem' }}>

                                        <div className='d-flex justify-content-between align-items-center mt-2'>
                                            <div>نام مشتری :</div>
                                            <div>{context.loggedIn.name}</div>
                                        </div>

                                        <div className='d-flex justify-content-between align-items-center mt-2'>
                                            <div>شماره تماس :</div>
                                            <div className='ltr'>
                                                {
                                                    context.loggedIn.mobile
                                                }
                                                <span className='mx-1'>
                                                    {(context.loggedIn.phone || context.mobile1) ? '-' : ''}
                                                </span>
                                                {
                                                    context.loggedIn.phone || context.loggedIn.mobile1 || context.loggedIn.mobile2 || context.loggedIn.phone1
                                                }

                                            </div>
                                        </div>
                                        <div className='mt-2' style={{ textAlign: 'justify' }}>
                                            <div>آدرس :</div>
                                            <div className='mt-1'> {context.loggedIn.address}</div>
                                        </div>
                                        <div className='facture-info-layer' ref={elementRef}>
                                            {
                                                !showInfo ?
                                                    <button className='btn btn-warning btn-sm mx-auto'
                                                        onClick={() => {
                                                            setShowInfo(true)
                                                            setTimeout(() => {
                                                                textInfoRef.current.focus()
                                                                setTimeout(() => {
                                                                    executeScroll()
                                                                }, 500);
                                                            }, 150);
                                                        }}
                                                    >
                                                        <i className='fa fa-pencil' style={{ marginLeft: '7px' }}></i>
                                                        افزودن توضیحات
                                                    </button>
                                                    :
                                                    <div>
                                                        <textarea
                                                            ref={textInfoRef}
                                                            className="form-control"
                                                            id="info"
                                                            rows="3"
                                                            placeholder="توضیحات"
                                                            value={context.factureInfo}
                                                            name="info"
                                                            aria-describedby="description"
                                                            onChange={(e) => setInfoHandler(e.target.value)}
                                                        ></textarea>
                                                        <div >
                                                            <span>
                                                                {maxInfoLength - context.factureInfo.length}
                                                            </span>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center mt-3 text-success fs-6'>
                                            <div>مجموع خرید</div>
                                            <div>{priceFormat(getTotalPrice())} {config.currencyType}</div>
                                        </div>
                                        <div className='text-center mt-3'>
                                            <button className='btn btn-block btn-success w-50'
                                                onClick={() => setShowConfirmModal(true)}
                                                disabled={submitLoading}
                                            >
                                                {
                                                    submitLoading &&
                                                    <IconLoading
                                                        type='spin'
                                                        color={'#fff'}
                                                    />
                                                }
                                                ثبت سفارش
                                            </button>
                                        </div>
                                    </section>
                                }
                            </div>
                        </section>
                        <ConfirmOrderModal
                            show={showConfirmModal}
                            handleClose={() => setShowConfirmModal(false)}
                            onConfirm={submitOrderHandler}
                            defaultMobile={context.loggedIn ? context.loggedIn.mobile : ''}
                        />
                    </div>
                    :
                    <div className='empty-shopping-cart'>
                        <Image
                            src={shopImage}
                            width={200}
                            height={164}
                            style={{ objectFit: 'cover', opacity: '.5' }}
                        />
                        <div className='mt-2'>
                            سبد خرید شما خالی است
                        </div>
                    </div>
            }

        </React.Fragment>
    );
}

export default ShoppingCart;